import { createSlice } from '@reduxjs/toolkit'
import {
  defaultPage,
  defaultSize,
  defaultSortDir,
  defaultTotalElements,
  defaultSortBy,
  defaultTotalPages,
} from '../../../constants/index'

const initialState = {
  getSchema: [],
  getSingleSchema: null,
  schemaPagination: [],
  getCustomerList: [],
  getClientRules: [],
  customerPaginationList: [],
  brandPaginationList: [],
  getSingleCustomer: null,
  getSingleBrand: null,
  getSingleClientRule: null,
  getUsecaseDto: [],
  getBrandList:[],
  pageable: {
    pageNo: defaultPage,
    pageSize: defaultSize,
    sortBy: defaultSortBy,
    sortDir: defaultSortDir,
    totalPages: defaultTotalPages,
    totalElements: defaultTotalElements,
  },

  customerPageable: {
    pageNo: defaultPage,
    pageSize: defaultSize,
    sortBy: defaultSortBy,
    sortDir: defaultSortDir,
    totalPages: defaultTotalPages,
    totalElements: defaultTotalElements,
  },

  brandPageable: {
    pageNo: defaultPage,
    pageSize: defaultSize,
    sortBy: defaultSortBy,
    sortDir: defaultSortDir,
    totalPages: defaultTotalPages,
    totalElements: defaultTotalElements,
  },

  clientRulesPageable: {
    pageNo: defaultPage,
    pageSize: defaultSize,
    sortBy: defaultSortBy,
    sortDir: defaultSortDir,
    totalPages: defaultTotalPages,
    totalElements: defaultTotalElements,
  },
}

const schemaSlice = createSlice({
  name: 'schema',
  initialState: initialState,
  reducers: {
    schemaFetched: (state, action) => {
      state.getSchema = action.payload
    },

    schemaFetchedById: (state, action) => {
      state.getSingleSchema = action.payload
    },
    schemaPaginationFetched: (state, action) => {
      state.schemaPagination = action.payload.content
      state.pageable = {
        ...state.pageable,
        pageNo: action.payload.pageNo,
        pageSize: action.payload.pageSize,
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages,
      }
    },
    customerFetched: (state, action) => {
      state.getCustomerList = action.payload
    },

    clientRulesFetched: (state, action) => {
      state.getClientRules = action.payload.content
      state.clientRulesPageable = {
        ...state.clientRulesPageable,
        pageNo: action.payload.pageNo,
        pageSize: action.payload.pageSize,
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages,
      }
    },

    customerPaginationFetched: (state, action) => {
      state.customerPaginationList = action.payload.content
      state.customerPageable = {
        ...state.customerPageable,
        pageNo: action.payload.pageNo,
        pageSize: action.payload.pageSize,
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages,
      }
    },
    brandPaginationFetched: (state, action) => {
      state.brandPaginationList = action.payload.content
      state.brandPageable = {
        ...state.brandPageable,
        pageNo: action.payload.pageNo,
        pageSize: action.payload.pageSize,
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages,
      }
    },

    brandListFetched: (state, action) => {
      state.getBrandList = action.payload
    },

    brandFetchedById: (state, action) => {
      state.getSingleBrand = action.payload
    },
    brandCleared: (state) => {
      state.getSingleBrand = null
    },
    customerFetchedById: (state, action) => {
      state.getSingleCustomer = action.payload
    },

    clientFetchedById: (state, action) => {
      state.getSingleClientRule = action.payload
    },

    useCaseDtoFetched: (state, action) => {
      state.getUsecaseDto = action.payload
    },
  },
})

export default schemaSlice